import { useEffect, useRef } from "react";

// Dev-Hilfe gegen Tabellen-Überlauf: misst den horizontalen Überstand des
// referenzierten Containers via ResizeObserver und schreibt eine Warnung in die
// Konsole, wenn Inhalt > Breite. Soll Regressionen beim Hinzufügen von Spalten
// sichtbar machen, bevor Reviewer sie übersehen. Nur in `import.meta.env.DEV`
// aktiv — Prod-Builds tragen den Hook null Cost.
export function useOverflowGuard<T extends HTMLElement>(name: string) {
  const ref = useRef<T | null>(null);
  useEffect(() => {
    if (!import.meta.env.DEV) return;
    const el = ref.current;
    if (!el) return;
    let lastWarnAt = 0;
    const check = () => {
      const overflow = el.scrollWidth - el.clientWidth;
      if (overflow > 1 && Date.now() - lastWarnAt > 2000) {
        lastWarnAt = Date.now();
        // eslint-disable-next-line no-console
        console.warn(
          `[OverflowGuard] "${name}": Inhalt ${overflow}px breiter als Container ` +
            `(scrollWidth=${el.scrollWidth}, clientWidth=${el.clientWidth}). ` +
            "Spalten reduzieren oder Container verbreitern.",
        );
      }
    };
    check();
    const observer = new ResizeObserver(check);
    observer.observe(el);
    return () => observer.disconnect();
  }, [name]);
  return ref;
}
